function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { withTheme } from 'styled-components';
import renderIf from '@signal/utils/renderIf';
import propTypeComponent from '@signal/prop-types/component';
import { Wrapper, Series, Color, Label, BadgeWrapper, RightContent } from './styles';
export function Legend(_ref) {
  var series = _ref.series,
      badgeComponent = _ref.badgeComponent,
      labelComponent = _ref.labelComponent,
      labelProps = _ref.labelProps,
      marginSpacing = _ref.marginSpacing,
      seriesMarginSpacing = _ref.seriesMarginSpacing,
      seriesStyle = _ref.seriesStyle,
      getFill = _ref.getFill,
      getLabel = _ref.getLabel,
      getRightContent = _ref.getRightContent,
      getId = _ref.getId,
      isDisabled = _ref.isDisabled,
      theme = _ref.theme,
      orientation = _ref.orientation,
      showRightContent = _ref.showRightContent,
      rest = _objectWithoutProperties(_ref, ["series", "badgeComponent", "labelComponent", "labelProps", "marginSpacing", "seriesMarginSpacing", "seriesStyle", "getFill", "getLabel", "getRightContent", "getId", "isDisabled", "theme", "orientation", "showRightContent"]);

  var BadgeComponent = badgeComponent || Color;
  var LabelComponent = labelComponent || Label;
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    orientation: orientation
  }, rest), series.map(function (s, i) {
    var fill = getFill(s, i); // if `fill` is a function, assume it's a theme selector

    if (isFunction(fill)) fill = fill(theme);
    return /*#__PURE__*/React.createElement(Series, {
      key: getId(s),
      style: seriesStyle,
      orientation: orientation,
      seriesMarginSpacing: seriesMarginSpacing
    }, /*#__PURE__*/React.createElement(BadgeWrapper, null, /*#__PURE__*/React.createElement(BadgeComponent, {
      color: fill,
      disabled: isDisabled(s),
      marginSpacing: marginSpacing
    }), /*#__PURE__*/React.createElement(LabelComponent, labelProps, getLabel(s))), renderIf(showRightContent, function () {
      return /*#__PURE__*/React.createElement(RightContent, null, /*#__PURE__*/React.createElement(LabelComponent, labelProps, getRightContent(s)));
    }));
  }));
}
export var legendSeriesPropType = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
  label: PropTypes.string.isRequired,
  fill: PropTypes.oneOfType([PropTypes.string, // theme selectors can be provided as `fill`
  PropTypes.func]).isRequired
}), PropTypes.object]));
Legend.propTypes = {
  getFill: PropTypes.func,
  getLabel: PropTypes.func,
  getId: PropTypes.func,
  series: legendSeriesPropType,
  isDisabled: PropTypes.func,
  badgeComponent: propTypeComponent,
  labelComponent: propTypeComponent,
  marginSpacing: PropTypes.number,
  seriesMarginSpacing: PropTypes.number,
  showRightContent: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
Legend.defaultProps = {
  getFill: function getFill(s) {
    return s.fill;
  },
  getLabel: function getLabel(s) {
    return s.label;
  },
  getId: function getId(s) {
    return s.label;
  },
  getRightContent: function getRightContent(s) {
    return s.value;
  },
  isDisabled: function isDisabled() {
    return false;
  },
  marginSpacing: 1,
  seriesMarginSpacing: 4,
  showRightContent: false,
  orientation: 'horizontal'
};
export default withTheme(Legend);